<template>
  <div class="swiper-container" :id="id">
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
      <div class="swiper-pagination"  slot="pagination"></div>   
  </div>
</template>

<script>
// headers
import Swiper from 'swiper' 
import 'swiper/css/swiper.css'
export default {
    name:"swipe",
    props:["id","options"],
    mounted(){
        let mySwiper = new Swiper("#"+this.id,this.options);

    },
    updated(){
         let mySwiper = new Swiper("#"+this.id,this.options);
    }
}
</script>